import type {ISketchObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from '../MultiTargetRelation';

let count = 0;

/**
 * 判断对象是否为点在曲线关系。
 * @param value 待判断对象。
 * @returns 是否为点在曲线关系。
 */
export function isPointCurveCoincidentConstraint(value: object): value is PointCurveCoincidentConstraint {
    return Reflect.get(value, 'isPointCurveCoincidentConstraint') === true;
}

/**
 * 点在基础曲线上的重合关系定义。
 *
 * 目标曲线类型与合法组合由统一公式注册表校验；本类不离散采样或直接投影点位。
 */
export class PointCurveCoincidentConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isPointCurveCoincidentConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Coincident;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '重合';
    }
}
